import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Field, Option, Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

// models
import { IdentifierTypeViewModel } from '../../../../models/Entities/Person/IdentifierType/IdentifierTypeModels';
import { PersonTypeEnum } from '../../../../models/Entities/Person/PersonCommands';

// functions
import * as ComponentFunctions from './IdentifierTypeSelector.Functions';

const IdentifierTypeSelectorComponent = (props: ComponentFunctions.Props) => {
  const [t] = useTranslation();

  useEffect(() => {
    props.GetIdentifierTypes();
  }, []);

  const availableTypes = props.identifierTypes.filter((item: IdentifierTypeViewModel) => {
    if (props.personType === undefined) return true;
    return props.personType === PersonTypeEnum.JuridicalPerson
      ? item.isForJuridicalPerson
      : item.isForLegalPerson;
  });

  const selected = availableTypes.find(
    (item: IdentifierTypeViewModel) => item.id === props.selectedIdentifierTypeId
  );

  const handleSelection = (identifierTypeId: string | undefined) => {
    props.onSelectionChange(identifierTypeId ? Number(identifierTypeId) : undefined);
  };

  return (
    <Field
      label={props.label || t('persons.identifierTypeSelector.label', { defaultValue: 'Tipo de identificación' })}
      required={props.isRequired || false}
      validationMessage={props.errorMessage}
      validationState={props.errorMessage ? 'error' : undefined}
    >
      {props.isLoading ? (
        <Spinner size="tiny" />
      ) : (
        <Dropdown
          disabled={props.isDisabled || false}
          placeholder={t('persons.identifierTypeSelector.placeholder', { defaultValue: 'Seleccione un tipo' })}
          value={selected?.name || ''}
          selectedOptions={selected ? [String(selected.id)] : []}
          onOptionSelect={(_, data) => handleSelection(data.optionValue)}
        >
          {availableTypes.map((item: IdentifierTypeViewModel) => (
            <Option key={item.id} value={String(item.id)} text={item.name || ''}>
              {item.name || ''}
            </Option>
          ))}
        </Dropdown>
      )}
    </Field>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(IdentifierTypeSelectorComponent as any);
